export default __webpack_public_path__ + "static/media/failed.47b044f7.png";